import { render, staticRenderFns } from "./FormPrintConfiguration.vue?vue&type=template&id=2c1b1fd0&"
import script from "./FormPrintConfiguration.vue?vue&type=script&lang=js&"
export * from "./FormPrintConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports